import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { Grid } from '../../../core/components/grid/Grid.js';
import { useHistogramXScale } from '../../hooks/useHistogramXScale.js';
import { useHistogramYScales } from '../../hooks/useHistogramYScales.js';

export const HistogramChartGridLayout = () => {
  const { width, height } = useGridPlotSize();
  const [leftScale] = useHistogramYScales();
  const { xScale } = useHistogramXScale();

  return (
    <svg className={plotLayout}>
      <Grid
        xScale={xScale}
        yScale={leftScale}
        height={height}
        width={width}
        data-testid="histogram-chart-grid-lines"
        highlightZeroLine={{
          vertical: false,
        }}
      />
    </svg>
  );
};

HistogramChartGridLayout['displayName'] = 'HistogramChartGridLayout';
